import React, { memo } from "react";
import { withStyles } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Clear from "@material-ui/icons/CancelOutlined";
import styles from "./styles";

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
    };
  }

  onSearchTextChange = (event) => {
    this.props.eventHub.emit(this.props.headerId, event.target.value);
    this.setState({ searchText: event.target.value });
  };

  onClear = () => {
    this.props.eventHub.emit(this.props.headerId, "");
    this.setState({ searchText: "" });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={`${classes.search} ${classes.iconLayout} glHeaderIcons`}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Search…"
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          onChange={this.onSearchTextChange}
          value={this.state.searchText}
          endAdornment={
            <Clear
              classes={{
                root: `${classes.clearIcon} ${
                  this.state.searchText
                    ? classes.iconVisible
                    : classes.iconHidden
                }`,
              }}
              onClick={this.onClear}
              display={this.state.searchText ? "none" : "block"}
            />
          }
        />
      </div>
    );
  }
}

export default withStyles(styles)(memo(SearchBar));
